module.exports = __webpack_public_path__ + "img/home_2.a3e00982.svg";